export interface TeacherDetails {
    id: number,
    name: string,
    possessiveName: string,
    displayName: string,
    prefix: string,
    challengeId: number,
    numActiveProjects: number,
    profilePhotoUrl: string,
    classroomPhotoUrl: string,
    classroomPhotoPendingScreening: string,
    classroomDescription: string,
    hbcuGrad: boolean,
    numFundedProjects: number,
    totalDonors: number,
    fundedProjectsYear: number,
    possessivePronoun: string,
}

export interface AddressDetails {
    city: string,
    state: string,
    stateFullName: string,
    zip: string,
}

export interface SchoolDetails {
    schoolId: number,
    name: string,
    address: AddressDetails,
    schoolPoverty: string,
    isEquityFocused: boolean,
}

export interface EssentialsListDetails {
    essentialsTopItemSummary: string,
    essentialsTopItemImageUrl: string,
    essentialsTopItemPrice: number,
    essentialsListLength: number,
    essentialsListUrl: string,
}

export interface TeacherProfileVO {
    teacherDetails: TeacherDetails,
    schoolDetails: SchoolDetails,
    essentialsListDetails: EssentialsListDetails,
    teacherProfileUrl: string,
    multipleRecurringDonationsEnabled: boolean,
    vanityUrl: string,
    showBirthdayBanner: boolean,
    hbcuGrad: boolean,
}

export interface SearchAPIReturnedProposal {
    fundingStatus: string,
    id: number,
}

export const PhotoTypes = {
    CLASSROOM: 'CLASSROOM',
    PROFILE: 'PROFILE',
} as const;

export type PHOTO_TYPE = (typeof PhotoTypes)[keyof typeof PhotoTypes] | null;
